import React from 'react';

import ReactTooltip from "react-tooltip";

export default class ProgressReviewTermTable extends React.Component
{
	static get defaultProps() 
	{
	    var v =
	    	{
	    		titles:
			  	{
				  default:
						[ 
							{text: 'Year', style: null },
							{text: 'Term', style: null },
							{text: 'Date', style: null },
							{text: 'Date Created', style: {textAlign: 'center'} },
							{text: '', style: null }
						]
				},
				externalData: false
	    	} ;

	    	return v ;
	}
	
	constructor(props) 
	{
		super(props);

		this.keyCount = 0 ;
		this.once = true ;

		let loading = true ;
		let data = [] ;

		if ( this.props.externalData === true )
		{
			loading = false ;

			data = this.props.data == null ? [] : this.props.data ;
		}

		// Create a state item here for all items on the form  (Using their id )
		this.state = {
				loading: loading,
				data: data,
				mode: this.props.mode,
		}

		this.onDialogClosed = this.onDialogClosed.bind(this) ;

		this.getdata () ;
	}

	onDialogClosed(operation)
	{
		if ( operation === 'saved')
		{
			this.getdata();
		}
	}

	getdata( )
	{
    	$.ajax({
    		  type: 'GET',
    		  url: Globals.APIFolder + '/reviews/term/all',
    		  success:(data)=>
			  {
    			  if ( checkError(data))
				  {
				  	const recs = data.status.rowsAffected == 0 ? [] : data.data ;

					this.setState ({ loading: false, data : recs}) ;
				  }
    		  },
    		  error:(jqXHR, textStatus, error)=>
			  {
					handleAjaxError ( jqXHR, textStatus, error )   		  	
			  }
    		  });
	}

	doCreateProgressReview(year_term_id )
	{
		$.ajax({
			type: 'PUT',
			url: Globals.APIFolder + '/reviews/term/' + year_term_id,
			data: { },
			beforeSend: () =>
			{
				showSpinner() ;
			},
			success:(data)=>{

				hideSpinner() ;

				if ( checkError(data))
				{
					this.getdata () ;
				}
			},
			error:(jqXHR, textStatus, error)=>
			{
				hideSpinner() ;

				handleAjaxError ( jqXHR, textStatus, error )
			}
		});
	}

	onCreateClick( year_term_id )
	{
		var self = this ;
		bootbox.confirm({
			title: "Generate Progress Review Requests?",
			message: "You are about to send progress Review requests to ALL of the Designated Teachers for this term<br><br>This will send an email to all Desi Teachers asking for progress review feedback and create an inbox item for each of them.<br><br>Are you sure you want to do this?",
			buttons: {
				cancel: {
					label: '<i class="fa fa-times"></i> Cancel'
				},
				confirm: {
					label: '<i class="fa fa-check"></i> Confirm'
				}
			},
			callback: function (result)
			{
				if ( result == true )
				{
					self.doCreateProgressReview (year_term_id) ;
				}
			}
		});
	}

	hyperlinkIcon ( params )
	{
		let icon_name =  params.icon;
		let color = params.color ;
		let link = params.link ;
		let onClick = params.onClick ;
		let tip = params.tip ;

		return React.createElement ( 'a', { key: this.keyCount++, onClick: onClick, href: link } ,
			React.createElement ('span', { key: this.keyCount++, 'data-tip' : tip, className: 'glyphicon '+icon_name, style: { color: color}})) ;
	}

	tableHeaderForMode ( mode )
	{
        var lineList=[];

        if ( this.props.titles != null )
    	{
        	if ( eval ( 'this.props.titles.'+mode) != null )
    		{
        		var titles = eval ( 'this.props.titles.'+mode) ;
    		}
        	else
    		{
        		var titles = this.props.titles.default ;
    		}
    	}
        
        if ( titles != null )
        {
        	var i = 0 ;
            var len = titles.length;
            var value = null ;
            
            for (i=0; i<len; ++i) 
            {
            	if (i in titles) 
            	{
            		value = titles[i];
            		
            		var txt = value.text ;
            		var style = value.style ;
            		
            		if ( style == null )
            		{
	            		lineList.push(React.createElement('th', {key:this.keyCount++}, txt));
					}
					else
					{
						lineList.push(React.createElement('th', {key:this.keyCount++, style: style}, txt));
					}
            	}
            }
        }
            
        return React.createElement('thead','',
               React.createElement('tr',{key:this.keyCount++}, lineList )) ;
		
	}

	tableBody()
	{
		return React.createElement('tbody',null,this.tableRows()) ;
	}

	padSpan ( text )
	{
		return React.createElement ( 'span', {key: this.keyCount++, style: {paddingLeft: '10px'}}, text) ;
	}

	boldSpan ( text )
	{
		return React.createElement ( 'span', {key: this.keyCount++, style: {fontWeight: 'bold'}}, text) ;
	}

	getYearDescForTerm ( row )
	{
		let desc = '' ;

		if ( row.description == null )
		{
			desc = "No Term" ;
		}
		else if ( row.description.length < 6 )
		{
			desc = +row.year_start + 1;
		}
		else if ( row.description.substr(0,6) == 'Autumn' )
		{
			desc = row.year_start;
		}
		else
		{
			desc = +row.year_start + 1;
		}

		return desc ;
	}

	tableRow ( row )
	{
		let lineList = [] ;

		let date_range = this.getYearDescForTerm(row);

		lineList.push(React.createElement('td', {key:this.keyCount++}, date_range));

		if ( row.full_half_indicator == 1)
		{
			lineList.push(React.createElement('td', {key:this.keyCount++}, this.boldSpan(row.description)));
		}
		else
		{
			lineList.push(React.createElement('td', {key:this.keyCount++}, this.padSpan(row.description)));
		}

		let range = row.date_from + " - " + row.date_to;

		lineList.push(React.createElement('td', {key:this.keyCount++}, range));

		if ( row.date_created != null )
		{
			lineList.push(React.createElement('td', {key:this.keyCount++, style: {textAlign: 'center'}}, row.date_created));
		}
		else
		{
			if ( row.progress_review_disabled === null )
			{
				lineList.push(React.createElement('td', {key:this.keyCount++, style: {textAlign: 'center'}},
					this.hyperlinkIcon ( { icon: 'glyphicon-export', tip: 'Create Review Requests for ' + row.description , color: '#5cb85c', link: '#' ,
						onClick: () => { this.props.clickHandler(row.year_term_id, this.onDialogClosed)} } )));
			}
			else
			{
				lineList.push(React.createElement('td', {key:this.keyCount++, style: {textAlign: 'center'}}, 'Skipped'));
			}
		}

		lineList.push(React.createElement('td', {key:this.keyCount++}, ''));

		return  React.createElement('tr', {key:this.keyCount++}, lineList) ;
	}

	tableRows ()
	{
    	return this.state.data.map(element =>
		{
			return this.tableRow ( element ) ;
		});
	}
	
	tableElement ()
    {
    	let lineList = [] ;


    	if ( this.state.data.length > 0 )
    	{
			lineList.push ( React.createElement ( 'div', { key:this.keyCount++, className: 'panel-body', style: { paddingBottom: '0px'} },
			React.createElement('table', {className: 'table table-striped'}, 
                this.tableHeaderForMode( this.props.mode ), 
                this.tableBody()))) ;
		}
		else
		{
			lineList.push ( React.createElement ( 'div', { key:this.keyCount++, className: 'panel-body' }, "No data to show")) ;
		}

		lineList.push ( React.createElement ( ReactTooltip, {key: 'tooltip1', className: 'tool-class', ref: 'tooltip' })) ;

		return lineList ;
    }
        
	render() 
    {
    	this.keyCount = 0 ;
    	
    	if ( this.state.loading == true )
    	{
	        return React.createElement('div', { key: this.keyCount++, className: ''}, "LOADING...");		    		
    	}
    	else
    	{
    		return this.tableElement() ;
    	}
    }
};
